import React, { useEffect, useRef, useState } from "react"
import { Card, Col, Row } from "reactstrap"
import UpdateTable from "../../../components/Common/UpdatedTable"
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import moment from "moment"
import { capitalize, isEmpty } from "lodash"
import { UFDate } from "../../../components/Common/Fields/Input"
import { useForm } from "react-hook-form"
import resetIcon from "../../../assets/icons/reset.svg"
import NumberFormat from "../../../utils/numberFormat"
import { useLocation, useNavigate } from "react-router-dom"
import CostCategoryFilter from "./filter"
import { fetchCostCenterReport } from "../../../services/finance/finance"
import { useSelector, useDispatch } from "react-redux"
import { setFilter, removeFilter } from "../../../store/actions"
import { createSelector } from "reselect"

const CostCategoryReport = ({ fromDashboard, projectId }) => {
  document.title = "Cost Category | Everise"

  const [search, setSearch] = useState("")
  const [fetchedData, setFetchedData] = useState()
  const [page, setPage] = useState(1)
  const [ccNo, setCCNo] = useState("")
  const [type, setType] = useState("")
  const [productNo, setProductNo] = useState("")
  const [financial, setFinancial] = useState(true)
  const [startDate, setStartDate] = useState("")
  const [endDate, setEndDate] = useState("")
  const [company, setCompany] = useState(false)
  const [datefrom, setDatefrom] = useState("")
  const [dateto, setDateto] = useState("")
  const [dataPerPage, setDataPerPage] = useState(25)
  const desimalrange = localStorage.getItem("desimalrange")
  const [isLoadingNextPage, setIsLoadingNextPage] = useState(false)
  const [productData, setProductData] = useState()

  const locations = useLocation();
  const crumb = locations?.state?.menuLabel || ""

  const dispatch = useDispatch()

  const selectFilterState = state => state.filterReducer
  const filterProperties = createSelector(selectFilterState, filter => ({
    filters: filter.filters,
    filterLoading: filter.loading,
    filterError: filter.error
  }))

  const { filters, filterLoading, filterError } = useSelector(filterProperties)
  console.log("filtersdata", filters, filterLoading, filterError)

  const { control, watch, reset } = useForm({
    defaultValues: {
      req_date: null,
    },
  })

  useEffect(() => {
    if (filters?.dateFrom || filters?.dateTo || filters?.productData || filters?.search) {
      setDatefrom(filters?.dateFrom || "")
      setDateto(filters?.dateTo || "")
      setProductData(filters?.productData || "")
      setSearch(filters?.search || "")
    const fetchData = async () => {
      const response = await fetchCostCenterReport({
        params: `${filters?.search ? `&searchText=${filters?.search}` : "&searchText"}${ccNo ? `&costcenter_id=${ccNo}` : ""
          }${`&sortOrder=asc`}${type ? `&type=${type}` : ""}${projectId ? `&project_id=${projectId}` : ""
          }${filters?.dateFrom ? `&start_date=${filters?.dateFrom}` : ""}${filters?.dateTo ? `&end_date=${filters?.dateTo}` : ""
          }${filters?.productData ? `&cost_category_id=${filters?.productData?.value}` : ""}${company == true ? `&company_search=""` : ""
          }${page ? `&page=${page}` : ""}${dataPerPage ? `&sizePerPage=${dataPerPage}` : ""}`,
      })
      // setFetchedData(response)
      const newData = response?.data?.data || [];

      console.log("responsedata", newData)

      setFetchedData(prev =>
        page > 1 && prev
          ? {
            ...response,
            data: {
              ...response.data,
              data: [...(prev.data?.data || []), ...newData],
            },
          }
          : response
      );
      setIsLoadingNextPage(response == undefined ? true : false)
      isLoadingRef.current = false;
      // ${`&financial=${financial}`}
    }
    
    if (
      filters?.dateFrom &&
      filters?.dateTo &&
      moment(filters?.dateFrom).isSameOrBefore(moment(filters?.dateTo)) &&
      filters?.productData
    ) {
      fetchData()
    }
  }
  }, [filters?.dateFrom, filters?.dateTo, filters?.productData, filters?.search])

  const location = useLocation()
  const navigate = useNavigate()
  const { productId, productName, bread } = location.state || {}

  const handlePaginate = page => {
    setPage(page)
  }

  const handleCCChange = id => {
    setCCNo(id)
    setPage(1)
  }

  const handleTypeChange = id => {
    setType(id)
    setPage(1)
  }

  const handleSearchChange = data => {
    setSearch(data)
    setPage(1)
  }
  const handleProductChange = data => {
    setProductNo(data?.value && typeof data?.value === "object" ? data.id : data?.value)
    setProductData(data)
    setPage(1)
    if (!data) {
      // Clear location.state
      navigate(location.pathname, { replace: true, state: {} })
    }
    if (data == undefined) {
      dispatch(removeFilter())
    }
  }

  const handleFinacialChange = id => {
    setFinancial(id)
    setPage(1)
  }

  useEffect(() => {
    if (filters?.dateFrom || filters?.dateTo || filters?.productData || filters?.search) return;
    const fetchData = async () => {
      const response = await fetchCostCenterReport({
        params: `${search ? `&searchText=${search}` : "&searchText"}${ccNo ? `&costcenter_id=${ccNo}` : ""
          }${`&sortOrder=asc`}${type ? `&type=${type}` : ""}${projectId ? `&project_id=${projectId}` : ""
          }${datefrom ? `&start_date=${datefrom}` : ""}${dateto ? `&end_date=${dateto}` : ""
          }${productNo ? `&cost_category_id=${productNo}` : ""}${company == true ? `&company_search=""` : ""
          }${page ? `&page=${page}` : ""}${dataPerPage ? `&sizePerPage=${dataPerPage}` : ""}`,
      })
      // setFetchedData(response)
      const newData = response?.data?.data || [];

      setFetchedData(prev =>
        page > 1 && prev
          ? {
            ...response,
            data: {
              ...response.data,
              data: [...(prev.data?.data || []), ...newData],
            },
          }
          : response
      );
      setIsLoadingNextPage(response == undefined ? true : false)
      isLoadingRef.current = false;
      // ${`&financial=${financial}`}
    }
    if (
      datefrom &&
      dateto &&
      moment(datefrom).isSameOrBefore(moment(dateto)) &&
      productNo
    ) {
      fetchData()
    }
  }, [
    type,
    financial,
    ccNo,
    search,
    projectId,
    startDate,
    endDate,
    company,
    page,
    datefrom,
    dateto,
    productNo,
    dataPerPage,
  ])

  const tableContainerRef = useRef(null)
  const isLoadingRef = useRef(false);
  const scrollTimeoutRef = useRef(null);

  useEffect(() => {
    const handleScroll = (e) => {
      const { scrollTop, scrollHeight, clientHeight } = e.target;
      
      if (scrollTimeoutRef.current) {
        clearTimeout(scrollTimeoutRef.current);
      }
      
      scrollTimeoutRef.current = setTimeout(() => {
        if (
          scrollTop + clientHeight >= scrollHeight - 50 &&
          !isLoadingRef.current &&
          page < fetchedData?.data?.last_page
        ) {
          isLoadingRef.current = true;
          setIsLoadingNextPage(true);
          setPage(prev => prev + 1);
        }
      }, 200);
    };
    
    const container = tableContainerRef.current;
    if (container) {
      container.addEventListener("scroll", handleScroll);
    }
    
    return () => {
      if (container) {
        container.removeEventListener("scroll", handleScroll);
      }
      if (scrollTimeoutRef.current) {
        clearTimeout(scrollTimeoutRef.current);
      }
    };
  }, [fetchedData, page]);


  const columns = [
    {
      label: "Date",
      renderCell: item => (item?.journal_entries?.transaction_date ? moment(item?.journal_entries?.transaction_date).format("DD-MMM-YYYY") : "-"),
    },
    {
      label: "Cost Center Name",
      renderCell: item => (item?.costcenter?.name ? capitalize(item?.costcenter?.name) : "-"),
    },
    {
      label: "Decsrption",
      renderCell: item =>
        item?.ledger?.name ? capitalize(item?.ledger?.name) : "-",
    },
    {
      label: "Voucher Type",
      renderCell: item => (item?.voucher_type ? item?.voucher_type : "-"),
    },
    {
      label: "Voucher No",
      renderCell: item => (
                <div
                  onClick={() => {
                    navigate(`/finance-voucher/view/${item?.voucher_entry?.id}`)
                    dispatch(setFilter({productData: productData, dateFrom: datefrom, dateTo: dateto, search: search}))
                  }
                  }
                  className="pointer fw-bold"
                >
                  {" "}
                  {item?.voucher_entry?.ref_number}{" "}
                </div>
              ),
    },
    {
      label: <div className="text-end pe-5">Debit Amount</div>,
      renderCell: item => (
        <>
          <div className="text-end pe-5">{NumberFormat(Number(item?.debit_amount || 0), desimalrange, desimalrange)}</div>
        </>
      ),
    },
    {
      label: <div className="text-end pe-5">Credit Amount</div>,
      renderCell: item => (
        <>
          <div className="text-end pe-5">{NumberFormat(Number(item?.credit_amount || 0), desimalrange, desimalrange)}</div>
        </>
      ),
    },
  ]
  const handleRequestdate = data => {
    let fromDate = ""
    let toDate = ""
    fromDate = !isEmpty(data) ? moment(data[0]).format("YYYY-MM-DD") : ""
    toDate = !isEmpty(data) ? moment(data[1]).format("YYYY-MM-DD") : ""
    setStartDate(fromDate)
    setEndDate(toDate)
  }

  const handleSizePerPageChange = size => {
    setDataPerPage(size)
  }

  const handleReset = () => {
    reset({ req_date: null })
    setStartDate("")
    setEndDate("")
  }

  const handleCompanyChange = id => {
    setCompany(id)
    setPage(1)
  }

  const handleDateChange = (fromdate, todate) => {
    console.log("datadatadate", fromdate, todate)
    setDatefrom(fromdate)
    setDateto(todate)
    setPage(1)
  }

  return (
    <React.Fragment>
      <div className={`page-content ${fromDashboard ? "pt-0" : ""}`}>
        <div className="container-fluid">
          <div className="d-flex justify-content-between">
            {!fromDashboard ? (
              <Breadcrumbs
                title="Finance"
                breadcrumbObject={[
                  { title: "Finance", link: "/finance" },
                  { title: `${bread ? bread : crumb || "Reports"}`, link: "/finance" },
                  {
                    title: "Cost Category Report",
                    link: "#",
                  },
                ]}
              />
            ) : (
              <></>
            )}
          </div>

          <Card
            className={`me-2 px-2 pb-2 ${fromDashboard ? "dash-table-bg" : ""}`}
          >
            {fromDashboard ? (
              <div className="px-2 py-3">Transaction History</div>
            ) : (
              <CostCategoryFilter
                // handleCCChange={handleCCChange}
                handleTypeChange={handleTypeChange}
                handleSearchChange={handleSearchChange}
                handleDateChange={handleDateChange}
                handleProductChange={handleProductChange}
                handleFinacialChange={handleFinacialChange}
                handleCompanyChange={handleCompanyChange}
                resetData={{fromData: datefrom, toData:  dateto, productData: productData, search: search}}
                {...(location?.state && {
                  productId,
                  productName,
                })}
              />
            )}
            <hr className="table-divide" />
            <div>
              {fromDashboard && (
                <Row className="pt-2">
                  <Col sm={6}>
                    <UFDate
                      control={control}
                      placeholder="Date"
                      name={"req_date"}
                      mode="range"
                      className="ufinput-dashboard"
                      onDateChange={e => handleRequestdate(e)}
                    />
                  </Col>
                  <Col sm={3}></Col>
                  <Col sm={3}>
                    <div
                      className="pointer me-2 text-white btn btn-primary float-end"
                      onClick={() => handleReset()}
                    >
                      <img
                        src={resetIcon}
                        height={15}
                        width={15}
                        className="me-2 svg-clr-reset"
                      />{" "}
                      Reset
                    </div>
                  </Col>
                </Row>
              )}
              <Row
                className={`ever-rise-table ${fromDashboard ? "dashboardTable" : ""
                  } `}
              >
                <Col xs={12}>
                <div ref={tableContainerRef} style={{ maxHeight: "490px", overflowY: "auto" }}>
                  {fetchedData?.data && productNo ? (
                    <>
                      <div className="d-flex justify-content-between px-2 py-3 fw-600">
                        <div>
                          Opening Balance:{" "}
                          {NumberFormat(
                            Math.abs(Number(fetchedData?.opening_balance || 0),
                              desimalrange,
                              desimalrange
                            ))}{" "}{Number(fetchedData?.closing_balance || 0) < 0 ? "Cr" : "Dr"}
                        </div>
                        {/* <div>
                          Current Balance:{" "}
                          {NumberFormat(
                            Math.abs(Number(fetchedData?.current_total?.debit ? fetchedData?.current_total?.debit : fetchedData?.current_total?.credit ? fetchedData?.current_total?.credit : 0),
                            desimalrange,
                            desimalrange
                          ))}{" "}{Number(fetchedData?.current_total?.credit) != 0 ? "Cr" : "Dr"}
                        </div> */}
                        <div>
                          Closing Balance:{" "}
                          {NumberFormat(
                            Math.abs(Number(fetchedData?.closing_balance || 0),
                              desimalrange,
                              desimalrange
                            ))}{" "}{Number(fetchedData?.closing_balance || 0) < 0 ? "Cr" : "Dr"}
                        </div>
                      </div>

                      <UpdateTable
                        className="mt-5"
                        nodes={fetchedData?.data}
                        paginate={fetchedData}
                        columns={columns}
                        CurrentPage={page}
                        handlePagination={handlePaginate}
                        handleSizePerPage={handleSizePerPageChange}
                        tableWidth="15% 15% 15% 15% 10% 15% 15%"
                        mobileWidth="50% 50% 50% 50%"
                        isLoading={isLoadingNextPage}
                        hidePaginate={true}
                      // showFooter={true}
                      />
                    </>
                  ) : (
                    <div className="d-flex align-items-center justify-content-center">
                      <p>Please select a Cost Category and date.</p>
                    </div>
                  )}
                  </div>
                </Col>
              </Row>
            </div>
          </Card>
        </div>
      </div>
    </React.Fragment>
  )
}

export default CostCategoryReport
